import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../../core/services/api.service';
import { environment } from '../../../../../environments/environment';
import {
  TemplateGridState,
  TemplateNotificationDataResponse,
} from '../model/template-notification-model';

@Injectable({
  providedIn: 'root',
})
export class TemplateNotificationService {
  private readonly baseUrl = `${environment.apiUrl}/api/SignatureRequest`;
  private readonly templateUrl = `${environment.apiUrl}/api/HRMFiles`;
  private readonly apiService = inject(ApiService);

  getTemplateNotificationData(
    body: TemplateGridState
  ): Observable<TemplateNotificationDataResponse> {
    return this.apiService.post<TemplateNotificationDataResponse>(
      `${this.baseUrl}/GridSignatureRequestData`,
      body
    );
  }
  GetByFileByTemplateId(id: number, fileId: number): Observable<any> {
    return this.apiService.get<any>(
      `${this.templateUrl}/GetByFileByTemplateId?id=${id}&fileId=${fileId}`
    );
  }

  GetTemplateDataByIdForFillInformation(id: number): Observable<any> {
    return this.apiService.get<any>(
      `${this.templateUrl}/GetTemplateDataByIdForFillInformation?id=${id}`
    );
  }
}
